/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneAuthorsList from 'base/components/standalone/AuthorsList';

export const DynamicStandaloneAuthorsList = StandaloneAuthorsList;
export type DynamicStandaloneAuthorsListProps = PropsFromComponent<typeof StandaloneAuthorsList>;

export const DynamicStandaloneAuthorsListWith = (extras: DynamicStandaloneExtras): typeof StandaloneAuthorsList => {
    return function DynamicStandaloneAuthorsList(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'AuthorsList');
        return <StandaloneAuthorsList {...mergeProps({ options: { theme } }, props)} />;
    }
}